import React from 'react';
import { companyInfo, partners } from '../../data/mock';
import { Linkedin, Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    produits: [
      { label: 'Carte Bronze', href: '#cards' },
      { label: 'Carte Silver', href: '#cards' },
      { label: 'Carte Gold', href: '#cards' },
      { label: 'Application Mobile', href: '#app' },
      { label: 'Solutions Entreprises', href: '#' },
    ],
    fidelite: [
      { label: 'Programme Rewards', href: '#loyalty' },
      { label: 'Niveaux de Fidélité', href: '#loyalty' },
      { label: 'Parrainage', href: '#' },
      { label: 'Catalogue Récompenses', href: '#' },
    ],
    partenaires: [
      { label: 'Wayne Energy', href: '#partners' },
      { label: 'KIDH Immobilier', href: '#partners' },
      { label: 'EKIPTECH', href: '#partners' },
      { label: 'Banques Partenaires', href: '#partners' },
      { label: 'Devenir Partenaire', href: '#partners' },
    ],
    support: [
      { label: 'Centre d\'Aide', href: '#' },
      { label: 'FAQ', href: '#faq' },
      { label: 'Contact', href: '#contact' },
      { label: 'Opposition Carte', href: '#' },
    ],
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          {/* Brand Column */}
          <div className="col-span-2">
            <img
              src={companyInfo.logoTransparent}
              alt="KIPAY"
              className="h-16 mb-4"
            />
            <p className="text-gray-400 text-sm mb-6 max-w-xs">
              {companyInfo.subtitle}. Solutions de paiement et programme de fidélité 
              pour l'écosystème EKIP.
            </p>

            {/* Contact Info */}
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                <span>Abidjan, Côte d'Ivoire</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <span>{companyInfo.contact.phone}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <span>{companyInfo.contact.email}</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#6B2C91] transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#6B2C91] transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#6B2C91] transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#6B2C91] transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Produits */}
          <div>
            <h4 className="font-semibold text-white mb-4">Produits</h4>
            <ul className="space-y-2">
              {footerLinks.produits.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Fidélité */}
          <div>
            <h4 className="font-semibold text-white mb-4">Fidélité</h4>
            <ul className="space-y-2">
              {footerLinks.fidelite.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Partenaires */}
          <div>
            <h4 className="font-semibold text-white mb-4">Partenaires</h4>
            <ul className="space-y-2">
              {footerLinks.partenaires.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold text-white mb-4">Support</h4>
            <ul className="space-y-2">
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-400 text-sm hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <span>© {currentYear} KIPAY. Tous droits réservés.</span>
              <span className="hidden md:inline">Filiale EKIP Holding Company</span>
            </div>
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">
                Conditions Générales
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Confidentialité
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Mentions Légales
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
